import React from "react";

// VerdictBlock — Tier 1. Renders the verdict sentence verbatim at the top of the
// band and HIDES THE ENTIRE BLOCK when the sentence is absent — the one exception
// to PanelTakeaway's "return null, leave the chart" rule. With no verdict, Tier 2
// becomes the top of the page (plan, state "no-sentences-at-all").
//
// SIZE: the takeaway scale (.gi-takeaway), matching the money takeaway beneath it
// — deliberately NOT the larger .gi-verdict. The sentence renders here directly
// rather than through PanelTakeaway's "verdict" variant precisely so this size
// change stays chat/voice-only: the CDP dashboard still renders its verdict at
// .gi-verdict via its own PanelTakeaway call, untouched.
//
// Takes a `panelKey` prop so it is channel-neutral: `voice_verdict` for Voice,
// `chat_verdict` for Chat (the tokens are channel-neutral and so is this component).
//
// `variant` controls the size. The default `"takeaway"` keeps the original
// chat/voice-band sizing (.gi-takeaway, matching the money takeaway beneath the v1
// band). The V6 ConversationPage passes `variant="verdict"`, which the user ruled
// (2026-09-04) must render at 1rem (text-base), font-weight 400 (font-normal) —
// matching every other panel takeaway on the page, smaller and lighter than the
// larger .gi-verdict scale it originally used. This sizing is specific to the My
// Agents Phone/Chat pages. Kept as an opt-in so the v1 band callers render as before.
//
// Render-only: never clamps, never fixes a fixed height, never ellipsizes.
const VerdictBlock = ({ panelKey = "voice_verdict", say, variant = "takeaway", children }) => {
  const text = say?.[panelKey];
  if (!text) return null;
  // The "verdict" variant renders the Phone/Chat headline at 1rem (text-base),
  // font-weight 400 (font-normal) — user ruling 2026-09-04, matching every other
  // panel takeaway on the page — smaller and lighter than the original .gi-verdict
  // scale. Scoped to the My Agents conversation pages.
  const textClass = variant === "verdict"
    ? "text-base font-normal leading-snug text-gray-900 dark:text-gray-100"
    : "gi-takeaway text-gray-700 dark:text-gray-300";
  return (
    <section className="mb-6">
      <p className={textClass}>{text}</p>
      {children}
    </section>
  );
};

export default VerdictBlock;
